import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const DocumentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  width: 100%;
  background: #f8f8f8;
  padding: 2rem;

  border-radius: 0.5rem;
  height: fit-content;

  h2 {
    font-size: 2rem;
    font-weight: 500;

    strong {
      font-weight: 700;
    }
  }
`

export const DocumentsContent = styled.div`
  display: flex;
  gap: 2.5rem;
  flex-direction: column;

  width: 100%;

  > button {
    margin-top: 1rem;
    margin-bottom: 3rem;
    align-self: flex-end;
  }
`

export const FileInputsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  width: 100%;

  @media ${MOBILE_WIDTH} {
    flex-direction: column;
  }
`

export const FileWithDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  width: 100%;
`

export const GhostInputs = styled.div`
  width: 100%;
`
